import { inferLiteral } from "client/utils"
import * as types from "./types"


export const setQidProductDocumentList = (
    documentList: types.QidProductDocumentList,
    documentIds: number[],
) => ({
    type: inferLiteral(types.QID_PRODUCT_DOCUMENT_LIST),
    documentList,
    documentIds,
})
export const setQidProductDocumentReloadList = (value: boolean) => ({
    type: inferLiteral(types.QID_PRODUCT_DOCUMENT_RELOAD_LIST),
    value,
})
